import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Drawer, Form, Input, Button, Select, Icon, message } from "antd";
import moment from "moment";

import InputCurrency, { currency2Float } from "~/components/UI/InputCurrency";
import { DatePicker } from "~/components/UI/DatePicker/Locale";
import * as contasReceberActions from "../actions";

var DrawerCreate = function(props) {
    var visible = props.visible;
    var onClose = props.onClose;
    var record = props.record;
    var onSuccess = props.onSuccess;
    var customers = props.customers || [];

    var dispatch = useDispatch();
    var categories = useSelector(function(state) { return state.settings['financeiro.categoria_contas_receber'] || []; });

    var [description, setDescription] = useState('');
    var [amount, setAmount] = useState('');
    var [dueAt, setDueAt] = useState(null);
    var [paidAt, setPaidAt] = useState(null);
    var [status, setStatus] = useState('pending');
    var [customerId, setCustomerId] = useState(null);
    var [categoryId, setCategoryId] = useState(null);
    var [notes, setNotes] = useState('');
    var [loading, setLoading] = useState(false);

    var isEdit = !!record;

    useEffect(function() {
        if (visible && record) {
            setDescription(record.description || '');
            setAmount(record.amount || '');
            setDueAt(record.due_at ? moment(record.due_at) : null);
            setPaidAt(record.paid_at ? moment(record.paid_at) : null);
            setStatus(record.status || 'pending');
            setCustomerId(record.customer_id || null);
            setCategoryId(record.category_id || null);
            setNotes(record.notes || '');
        } else if (visible) {
            setDescription('');
            setAmount('');
            setDueAt(null);
            setPaidAt(null);
            setStatus('pending');
            setCustomerId(null);
            setCategoryId(null);
            setNotes('');
        }
    }, [visible, record]);

    var handleSubmit = function() {
        if (!description.trim()) { message.error('Informe a descricao'); return; }
        var amountVal = typeof amount === 'string' ? currency2Float(amount) : amount;
        if (!amountVal || amountVal <= 0) { message.error('Informe o valor'); return; }
        if (!dueAt) { message.error('Informe o vencimento'); return; }

        setLoading(true);
        var data = {
            description: description.trim(),
            amount: amountVal,
            due_at: dueAt.format('YYYY-MM-DD'),
            paid_at: status === 'paid' && paidAt ? paidAt.format('YYYY-MM-DD') : null,
            status: status,
            customer_id: customerId || null,
            category_id: categoryId || null,
            notes: notes || null,
        };

        var action = isEdit
            ? contasReceberActions.updateContaReceber(record.id, data)
            : contasReceberActions.createContaReceber(data);

        dispatch(action)
            .then(function() {
                message.success(isEdit ? 'Conta atualizada!' : 'Conta criada!');
                setLoading(false);
                if (onSuccess) onSuccess();
            })
            .catch(function() {
                message.error('Erro ao salvar.');
                setLoading(false);
            });
    };

    return (
        <Drawer
            title={isEdit ? 'Editar Conta a Receber' : 'Nova Conta a Receber'}
            placement="right"
            width={480}
            visible={visible}
            onClose={onClose}
            bodyStyle={{ paddingBottom: 80 }}
        >
            <Form layout="vertical">
                <Form.Item label="Descricao *">
                    <Input value={description} onChange={function(e) { setDescription(e.target.value); }} placeholder="Ex: Consultoria, Honorario..." />
                </Form.Item>
                <div style={{ display: 'flex', gap: 16 }}>
                    <Form.Item label="Valor *" style={{ flex: 1 }}>
                        <InputCurrency value={amount} onChange={function(v) { setAmount(v); }} style={{ width: '100%' }} />
                    </Form.Item>
                    <Form.Item label="Vencimento *" style={{ flex: 1 }}>
                        <DatePicker value={dueAt} onChange={function(d) { setDueAt(d); }} style={{ width: '100%' }} />
                    </Form.Item>
                </div>
                <Form.Item label="Cliente (opcional)">
                    <Select value={customerId || undefined} placeholder="Selecione um cliente" allowClear showSearch
                        optionFilterProp="children"
                        filterOption={function(input, option) { return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0; }}
                        onChange={function(v) { setCustomerId(v || null); }}
                        style={{ width: '100%' }}
                    >
                        {customers.map(function(c) { return <Select.Option key={c.id} value={c.id}>{c.cod + ' - ' + c.name}</Select.Option>; })}
                    </Select>
                </Form.Item>
                <Form.Item label="Categoria (opcional)">
                    <Select value={categoryId || undefined} placeholder="Selecione" allowClear
                        onChange={function(v) { setCategoryId(v || null); }}
                        style={{ width: '100%' }}
                    >
                        {categories.map(function(c) { return <Select.Option key={c.id} value={c.id}>{c.value}</Select.Option>; })}
                    </Select>
                </Form.Item>
                <div style={{ display: 'flex', gap: 16 }}>
                    <Form.Item label="Status" style={{ flex: 1 }}>
                        <Select value={status} onChange={function(v) { setStatus(v); }} style={{ width: '100%' }}>
                            <Select.Option value="pending">Pendente</Select.Option>
                            <Select.Option value="paid">Recebido</Select.Option>
                        </Select>
                    </Form.Item>
                    {status === 'paid' && (
                        <Form.Item label="Data de recebimento" style={{ flex: 1 }}>
                            <DatePicker value={paidAt} onChange={function(d) { setPaidAt(d); }} style={{ width: '100%' }} />
                        </Form.Item>
                    )}
                </div>
                <Form.Item label="Observacoes">
                    <Input.TextArea value={notes} onChange={function(e) { setNotes(e.target.value); }} rows={3} placeholder="Observacoes..." />
                </Form.Item>
            </Form>

            <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, borderTop: '1px solid #e8e8e8', padding: '12px 24px', background: '#fff', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                <Button onClick={onClose}>Cancelar</Button>
                <Button type="primary" loading={loading} onClick={handleSubmit}>
                    {isEdit ? 'Salvar' : 'Criar'}
                </Button>
            </div>
        </Drawer>
    );
};

export default DrawerCreate;
